import React from 'react';
import { messageUtility } from '../../utilities/messageUtility';
import { Information } from './common/';

export const BankenInfoDialog = ({ visible, onClose }) => (
  <Information
    title={CONSTANTS.DIALOG_TITLE}
    message={
      <React.Fragment>
        <p>Buildee入退場管理の機能がONに設定されました。</p>
        <br />
        <p>BANKEN入退場機器のお申し込みはお済みでしょうか。</p>
        <br />
        <p>
          入退場機器のお申し込みがお済みでない場合は、以下のリンクよりお申し込みをいただけます。
        </p>
        <br />
        <p>機器の到着は、お申し込み日より最短で8営業日後となります。</p>
        <hr />
        <p>・お申し込みはこちら</p>
        <a
          className='btn-text--sm'
          style={{ textIndent: '2rem' }}
          href={CONSTANTS.BANKEN_APPLY_URL}
          target='_blank'
          rel='noreferrer noopener'
        >
          お申込みフォーム
        </a>
        <br />
        <p>・機器の詳細はこちら</p>
        <a
          className='btn-text--sm'
          style={{ textIndent: '2rem' }}
          href={CONSTANTS.BANKEN_DEVICES_URL}
          target='_blank'
          rel='noreferrer noopener'
        >
          製品ラインナップ
        </a>
      </React.Fragment>
    }
    buttonText={messageUtility.getMessage('I-000-017')}
    visible={visible}
    onClose={onClose}
    multilineText={true}
  />
);

const CONSTANTS = {
  DIALOG_TITLE: 'BANKEN入退場機器のご案内',
  BANKEN_APPLY_URL: 'https://device-banken.jp/apply/',
  BANKEN_DEVICES_URL: 'https://device-banken.jp/recognitiondevices/',
};



// WEBPACK FOOTER //
// ./src/components/modals/BankenInfoDialog.jsx